import ReactGA from 'react-ga4';
import { AbstractTracker, TrackEventParameters } from './AbstractTracker';

export class GAModule extends AbstractTracker {
  settings = {};

  init(): void {
    ReactGA.initialize(process.env.REACT_APP_GA_MEASUREMENT_ID || '');
    // GA4 rastreia automaticamente as mudanças de página após a inicialização
    // Não é necessário chamar send() manualmente
  }

  trackEvent(parameters: TrackEventParameters): void {
    ReactGA.event({
      category: 'Event',
      action: parameters.event,
    });
  }

  peopleSet(event: string, parameter: any): void {}

  peopleSetOnce(event: string, parameter: any): void {}

  identify(identifier: string): void {}

  register(parameters: object): void {}
}
